module.exports = __webpack_public_path__ + "images/emoji/pisces.4e35418fd01917195ae7.png";